import React, { PureComponent } from 'react';
import { Table, Button as AntdButton, message } from 'antd';
import * as numeral from 'numeral';
import moment from 'moment';
import { connect } from 'react-redux';
import { withActions, isBusy } from 'actionware';
import { getTranslate } from 'react-localize-redux';

import { moneyFormat, dateTimeFormat, jsonDateFormat } from '../../common/constants';
import Section from '../../components/section/section';
import Panel from '../../components/panel/panel';
import { getTransactions } from './transactionActions';
import { downloadReport } from '../application/applicationApprovalActions';
import { isLenderPortfolioApiEnabled } from '../../common/config';

@connect(({
  localize,
  transaction: { showingTransactionModal, lenders, transactions, summary, totalData }
}) => ({
  translate: getTranslate(localize),
  showingTransactionModal,
  lenders,
  transactions,
  summary,
  totalData,
  loading: isBusy(getTransactions)
}))
@withActions({ getTransactions, downloadReport })
class TransactionTable extends PureComponent {
  constructor() {
    super();
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleDownloadReport = this.handleDownloadReport.bind(this);
  }

  handlePaginationChange(current, size) {
    const { currentLenderId, getTransactions } = this.props;
    const params = {
      page: current,
      size,
      type: 'all',
      lender_id: currentLenderId
    };
    getTransactions(params);
  };

  handleTableChange(pagination, filters) {
    const { currentLenderId, getTransactions } = this.props;
    const params = {
      page: pagination.current,
      size: pagination.pageSize,
      type: 'all',
      lender_id: currentLenderId,
    };
    getTransactions(params);
  };

  handleDownloadReport = () => {
    const { downloadReport, currentLenderId } = this.props;
    const today = moment().format(jsonDateFormat);
    const params = {
      report_type: 'topupcashout',
      lender_id: currentLenderId
    };
    downloadReport(params).then(({ data }) => {
      if (!data || Object.keys(data).length <1) {
        return message.error('Empty report');
      }
      const csvBlob = new Blob([data], { type: 'type/csv' });
      const url = window.URL.createObjectURL(csvBlob);
      const shadowLinkTag = document.createElement('a');
      shadowLinkTag.href = url;
      shadowLinkTag.download = `TopUpCashOut_(${currentLenderId})_(${today}).csv`;
      shadowLinkTag.click();
    });
  };

  render() {
    const { translate, transactions, summary, loading, totalData } = this.props;
    const columns = [
      {
        title: translate('transaction.lenderId'),
        dataIndex: 'lender_id',
        key: 'lender_id',
      },
      {
        title: translate('transaction.txnNo'),
        dataIndex: 'transaction_id',
        key: 'transaction_id',
      },
      {
        title: translate('transaction.lenderName'),
        dataIndex: 'lender_name',
        key: 'lender_name',
      },
      {
        title: translate('transaction.transactionDate'),
        dataIndex: 'transaction_date',
        key: 'transaction_date',
        render: value => moment(value).format(dateTimeFormat)
      },
      {
        title: translate('transaction.transactionType'),
        dataIndex: 'transaction_type',
        key: 'transaction_type',
      },
      {
        title: translate('transaction.transactionAmount'),
        dataIndex: 'transaction_amount',
        key: 'transaction_amount',
        render: value => numeral(value).format(moneyFormat)
      },
    ];

    return (
      <>
        {isLenderPortfolioApiEnabled() && <Section className="application-summary">
          <Panel className="active-loan" title={translate('transaction.totalLendersFund')}>
            <h1>
              {numeral(summary.total_lender_funding_amount).format(moneyFormat)}
            </h1>
          </Panel>
          <Panel className="closed" title={translate('transaction.remainingFundingAmount')}>
            <h1>
              {numeral(summary.remaining_funding_amount).format(moneyFormat)}
            </h1>
          </Panel>
        </Section>}
        <Table
          columns={columns}
          dataSource={transactions}
          bordered
          rowKey="id"
          loading={loading}
          pagination={{
            total: totalData,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50'],
            onShowSizeChange: this.handlePaginationChange
          }}
          onChange={this.handleTableChange}
        />
        <AntdButton
          className="excel-download"
          onClick={this.handleDownloadReport}>
          Download ke Excel
        </AntdButton>
      </>
    )
  }
}

export default TransactionTable;
